import React, { useState } from "react";
import { Navigate } from "react-router";
import { Box, styled, Tooltip, IconButton } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { translate } from "i18n";

interface ICreateChannelProps {
  disabled: boolean;
}

export function CreateChannelButton(createChannelButtonProps: ICreateChannelProps): React.ReactElement {
  const [redirectCreate, setRedirectCreate] = useState(false);

  function handleCreate(): void {
    setRedirectCreate(true);
    window.history.pushState({}, "/mosaic");
  }

  return (
    <Box style={{marginTop: '12px',marginLeft: '12px',marginRight: '6px'}}>
      <Tooltip title={translate("Add channel")}>
        <IconButton style={{margin: '8px', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.6)'}} onClick={handleCreate} disabled={createChannelButtonProps.disabled}>
          <AddIcon style={{ fontSize: '48px', color: 'black' }} />
        </IconButton>
      </Tooltip>
      {redirectCreate ? <Navigate to="/channelDetail/create" /> : null}
    </Box>
  );
}
